import React from "react";
import classnames from "classnames";

interface MegaTabProps {
  label: string;
  onClick: () => void;
  active?: boolean;
}

export const MegaTab = (props: MegaTabProps) => {
  const className = classnames("inline-block rounded-full px-3 py-2.5 txt-body-mobile-12 select-none cursor-pointer", {
    "bg-off-black text-white": props.active,
    "text-label hover:text-ash": !props.active,
  });
  return (
    <div className={className} onClick={props.onClick}>
      {props.label}
    </div>
  );
};
